<template>
    <div class="check-table" ref="checkTable">
        <div class="table-top">
            <span v-loading="loading" class="table-top_btn" @click="bindSave">保存模板</span>
        </div>
        <el-table
            v-if="tableHeight != 0"
            ref="editTable"
            :data="checkIndicators"
            :header-cell-style="{ background: '#f2f2f2', color: '#222' }"
            :height="tableHeight"
            border
            class="el-table"
            style="width: 100%;"
            >
            <el-table-column
                align="center"
                prop="targetNameCh"
                width="230"
                label="指标名称"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="source"
                width="70"
                label="来源"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width="70"
                prop="frequence"
                label="频率"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width="70"
                prop="unit"
                label="单位"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="startDate"
                label="开始时间"
                width="100"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{ setTime(scope.row.startDate) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="endDate"
                label="结束时间"
                width="100"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{ setTime(scope.row.endDate) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="remark"
                label="描述"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" align="center" width="80" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        style="color: #D3131A;"
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 添加模板 -->
        <add-template ref="addTemplate" :title="1"></add-template>
    </div>
</template>

<script>
import { parseTime, formatDate } from "@/utils/ruoyi"
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AddTemplate from './addTemplate'

export default {
    props: {
        tableHeight: {
            type: Number,
            default: 0
        }
    },
    components: { AddTemplate },
    computed: {
        ...mapGetters(["indicators", "checkIndicators", "isAdd", "templateInfo", "token"]),
        // 设置时间
        setTime() {
            return function (time) {
                return parseTime(formatDate(time), '{y}-{m}-{d}')
            }
        }
    },
    watch: {
        checkIndicators: {
            handler(value) {
                if (value) {
                    this.$nextTick(() => {
                        this.$refs.editTable.bodyWrapper.scrollTop = this.$refs.editTable.bodyWrapper.scrollHeight;
                    })
                }
            },
            deep: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapMutations(["SET_CHECK_INDICATORS"]),
        ...mapActions(["AddTemplate", "GetTemplate"]),
        // 删除模板
        handleDelete(row) {
            this.SET_CHECK_INDICATORS({row, type: 2})
        },
        // 保存模板
        bindSave() {
            if (this.indicators.length === 0) return;
            if (!this.token) {
                this.$message.error("未登录或登录状态已过期，请重新登录")
                const fullPath = this.$route.fullPath
                this.$router.push(`/login?redirect=${fullPath}`)
                return
            }
            // 获取所选的id
            let targetIds = []
            if (this.checkIndicators.length > 0) {
                this.checkIndicators.forEach(item => {
                    targetIds.push(item.id)
                })
            }
            if (this.isAdd) {
                // 编辑指标
                this.loading = true
                const form = {
                    id: this.templateInfo.id,
                    targetIds: targetIds.join(",")
                }
                this.AddTemplate(form).then(res => {
                    this.loading = false
                    this.$emit("changeLeft", 1)
                }).catch(() =>{
                    this.loading = false
                })
            } else {
                // 新增指标
                const form = {
                    id: null,
                    name: "模板1",
                    targetIds: targetIds.join(",")
                }
                this.$refs.addTemplate.deal(form)
            }
        }
    }
};
</script>

<style lang="less">
@import '../common.less';
.el-tooltip__popper {
  max-width: 60% !important;
}
.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  max-width: 60% !important;
  line-height: 24px;
  color: #fff !important;
}
</style>